<template>
  <v-card-text>
    <v-row justify="center">
      <v-col class="py-0" cols="12" md="6">
        <InputImageCrop codigo="01" label="Frente" />
      </v-col>
      <v-col class="py-0" cols="12" md="6">
        <InputImageCrop codigo="04" label="Traseira" />
      </v-col>
      <v-col class="py-0" cols="12" md="6">
        <InputImageCrop codigo="02" label="Lateral Esquerda" />
      </v-col>
      <v-col class="py-0" cols="12" md="6">
        <InputImageCrop codigo="03" label="Lateral Direita" />
      </v-col>
    </v-row>
  </v-card-text>
</template>

<script>
import InputImageCrop from '../InputImageCrop.vue';

export default {
  name: 'TabFoto',
  components: { InputImageCrop },
  data: () => ({}),
};
</script>
